import clsx from 'clsx';
import React from 'react';

import { CommentUser } from '@utils/backend-api/comments';

import UserProfileLink from '../../User/UserProfileLink';
import { userName } from '../../User/userHelpers';

export default function CommentAvatar({
  user,
  className,
}: {
  user: CommentUser;
  className?: string;
}) {
  const name = userName(user);

  return (
    <UserProfileLink user={user} className={clsx('comment-avatar-link', className)}>
      {user.picture_url ? (
        <img src={user.picture_url} alt={name} className="comment-avatar h-56 w-56 max-w-full" />
      ) : (
        <div className="flex h-[55px] w-[55px] items-center justify-center rounded-[125px] border-r border-solid border-white bg-grayscale-charcoal font-suisse-intl-mono text-feed-headline-lg text-white">
          <div className="comment-avatar-placeholder">{name ? name[0] : ''}</div>
        </div>
      )}
    </UserProfileLink>
  );
}
